import React from 'react';

import {MainLayout} from 'widgets/layout';
import {listPageClassName} from 'shared/ui/ListPage/ListPage';
import {HttpIncidentsScreen} from 'features/http';

const HttpIncidentsPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <HttpIncidentsScreen />
        </MainLayout>
    );
};

export default HttpIncidentsPage;
